import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AppTokenHandler {
    public access_token_key = 'access_token';
    access_token_value = '';
    loginUserInfo: UserInfo;
    public azure_token_key = 'azure_token';
    azure_token_value = '';
    // public IsAuthenticated = this.getIsAuthenticated();
    roleList: string[];

    constructor(private cookieService: CookieService) {

    }

    getSessionToken() {
        const isAccessTokenExists: boolean = this.cookieService.check(
            this.access_token_key
        );
        if (isAccessTokenExists) {
            this.access_token_value = this.cookieService.get(this.access_token_key);
        } else {
            this.access_token_value = '';
        }
        return this.access_token_value;

    }

    setSessionToken(loginData) {
        this.access_token_value = loginData.access_token;
        loginData.access_token = "";
        sessionStorage.setItem('UserInfo', JSON.stringify(loginData));
        this.cookieService.set(this.access_token_key, this.access_token_value, 1, undefined, undefined, true, 'Lax');
    }

    clearSessionToken() {
        this.cookieService.delete(this.access_token_key);
        this.access_token_value = '';
        sessionStorage.removeItem('UserInfo');
        sessionStorage.removeItem(this.access_token_key);
        sessionStorage.clear();
        localStorage.clear();
    }

    getLoginUserInfo() {
        this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
        return this.loginUserInfo;
    }

    IsInRole(role: string): boolean {
        let validRole = false;
        const loginInfo: UserInfo = this.getLoginUserInfo();
        const roles: string[] = loginInfo.Roles.split(',');
        if (roles.find(x => x.indexOf(role) >= 0)) {
            validRole = true;
        }
        return validRole;
    }

    GetRolesList = (): any => {
        const loginInfo: UserInfo = this.getLoginUserInfo();
        this.roleList = loginInfo.Roles.split(',');
        return this.roleList;
    }

    setAzureTokenInCookie(azureToken: string): void {
        if (azureToken) {
            this.azure_token_value = azureToken;
            this.cookieService.set(this.azure_token_key, this.azure_token_value, 1, undefined, undefined, true, 'Lax');
        }
    }

    clearAllAzureCookie() {
        this.cookieService.delete(this.azure_token_key);
        this.cookieService.deleteAll();
    }

    getAzureTokenFromCookie(): string {
        const isAzureTokenExists: boolean = this.cookieService.check(this.azure_token_key);
        if (isAzureTokenExists) {
            this.azure_token_value = this.cookieService.get(this.azure_token_key);
        } else {
            this.azure_token_value = ''
        }
        return this.azure_token_value;
    }
    // private getIsAuthenticated() {
    //     if (sessionStorage.getItem('UserInfo') !== null) {
    //         this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
    //         return this.loginUserInfo.IsAuthenticated;
    //     } else {
    //         return false;
    //     }
    // }
}

@Injectable()
export class UserInfo {
    UserId: string;
    EmpGPN: string;
    EmpEmail: string;
    EmpName: string;
    IssuedUtc: Date;
    ExpiresUtc: Date;
    Roles: string;
    UserImage: string;
    access_token: string;
    IsConsent: boolean;
    IsAuthenticated: boolean;
    isAzureLogAppInsights!: boolean;

}

@Injectable()
export class HTTPStatus {
    private requestInFlight$: BehaviorSubject<boolean>;
    constructor() {
        this.requestInFlight$ = new BehaviorSubject(false);
    }

    setHttpStatus(inFlight: boolean) {
        this.requestInFlight$.next(inFlight);
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
}
